


import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MenuComponent } from './components/menu/menu.component';
import { PaymentSuccessComponent } from '../payment-success/payment-success.component';
import { PaymentFailureComponent } from '../payment-failure/payment-failure.component';

const routes: Routes = [
  {
    path: 'home-page',
    loadChildren: () => import('./pages/home-page/home-page.module').then(m => m.HomePageModule),
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/splash/splash.module').then(m => m.SplashPageModule)
  },
  {
    path: 'operations',
    loadChildren: () => import('./pages/operations/operations.module').then(m => m.operationsModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/viewprofile/viewprofile.module').then(m => m.viewprofilePageModule),
  },
  {
    path: 'myprofile',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
  },
  {
    path: 'menu',
    component:MenuComponent
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'recharge',
    loadChildren: () => import('./pages/recharge/recharge.module').then(m => m.rechargeModule),
  },
  { path: 'payment-success', component: PaymentSuccessComponent },
  { path: 'payment-failure', component: PaymentFailureComponent },
  {
    path: 'splash',
    loadChildren: () => import('./pages/splash/splash.module').then(m => m.SplashPageModule)
  },
  {
    path: 'changepassword',
    loadChildren: () => import('./pages/changepassword/changepassword.module').then(m => m.changepasswordPageModule)
  },
  {
    path: 'viewprofile',
    loadChildren: () => import('./pages/viewprofile/viewprofile.module').then(m => m.viewprofilePageModule)
  },
  {
    path: 'digitalcard',
    loadChildren: () => import('./pages/digitalcard/digitalcard.module').then(m => m.digitalcardModule)
  },
  {
    path: 'newmember',
    loadChildren: () => import('./pages/newmember/newmember.module').then(m => m.newmemberModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
